<template>
    <div class="messageviewwrap" @keydown="doKeyDown" tabindex="0" ref="wrap">
        <vue-headful :title="title"></vue-headful>
        <message-control-bar class="controls"
                :extWindow="extWindow"
                :folderid="folderid" :msgid="msgid" :rights="rights"
                :replyOptions="{ replyList: canReplyList }"
                @updateMessages="$emit('updateMessages', $event)"
                @deleteMessages="$emit('deleteMessages', $event)"
                @moveMessages="$emit('moveMessages', $event)" @menu="doMenu"
                @message="doMessage"/>
        <!--<message-control-bar v-show="displayMessage && 0" @hide="hideMessage"
                @delete="deleteCurrentMessage"
                @markUnread="markCurrentMessageUnread"
                @move="moveCurrentMessage"/>-->
        <message-pager v-if="!extWindow" :pageLength="1" class="pager mq-mdplus"
                :start="selectedMessageNumber"
                :totalLength="totalFolderSize"
                @page="$emit('page', $event)"></message-pager>

        <section class="messagecontentwrap" :class="{loading}" v-resize="doResize" v-touch:swipe="doSwipe">
            <section class="messageloading" v-show="loading">
                <div><font-awesome-icon icon="spinner-third" spin size="4x"/></div>
            </section>
            <header>
                <div class="subject">{{$t('messageView.subject')}}{{subject}}</div>
                <div class="from">{{$t('messageView.from')}}{{fromName}}
                    <span class="fromextra">{{fromAddr}}</span>
                </div>
                <div class="date">{{date}}</div>
                <div class="flag">
                    <font-awesome-icon :icon="flagged ? 'star' : ['fal', 'star']"
                            :class="flagged ? 'flagged' : ''" @click="flagMessage"/>
                </div>
                <div class="recipients" ref="recipients">
                    <span class="rcptWrap toWrap" v-if="recipientsTo.length > 0">
                        <span class="rcptLabel toLabel">{{$t('messageView.to')}}</span>
                        <span v-for="(r, ind) in recipientsTo" :key="`to-${ind}`" :title="r.addr" class="rcpt">
                            {{r.name}}<span v-if="ind+1 < recipientsTo.length">{{$t('messageView.toSeparator')}}</span>
                        </span>
                    </span>
                    <span class="rcptWrap ccWrap" v-if="recipientsCc.length > 0">
                        <span class="rcptLabel ccLabel">{{$t('messageView.cc')}}</span>
                        <span v-for="(r, ind) in recipientsCc" :key="`cc-${ind}`" :title="r.addr" class="rcpt">
                            {{r.name}}<span v-if="ind+1 < recipientsCc.length">{{$t('messageView.ccSeparator')}}</span>
                        </span>
                    </span>
                </div>
                <div class="recipientsoverflow" v-show="rcptsOverflowed">overflow</div>
                <div class="spamdata" v-show="folderId===-2">
                    <span class="spamdatalabel">{{$t('messageView.spamdataLabel')}}</span>
                    <span class="spamdata">{{spamdata}}</span>
                </div>
            </header>
            <attachments-viewer :attachments="attachments" :folderId="folderId" :message="message"></attachments-viewer>
            <div class="imagesBlocked" v-if="imagesBlocked && !allowImages">
                <span v-if="this.$store.state.settings.allowwebmailimages">
                    {{$t('messageView.imagesBlocked')}}
                    <span v-if="folderId !== -2">
                        <a class="ml-3" href="#" @click="unblockImages(false)">{{$t('messageView.showImagesOnce')}}
                        </a>

                        <a class="ml-3" @click="unblockImages(true)">
                            {{$t('messageView.showImagesFromSender', { sender: from.addr})}}
                        </a>
                    </span>
                </span>
                <span v-else>
                    {{$t('messageView.imagesBlockedByAdministrator')}}
                </span>
            </div>
            <i-frame id="msgiframe">
                <message-body ref="msgbody" :data="displayParts" :structure="structure" :folderId="folderId"
                        :message="message" @focus="onFocusIframe" @swipe="doSwipe"
                        :allowImages="allowImages || allowSenderImages" @imagesBlocked="imagesBlocked=true"/>
            </i-frame>
        </section>

    </div>
</template>

<script>
import axios from 'axios';
import iFrame from '@/components/iframe';
import MessageBody from '@/components/messageBody';
import parseAddrs from '@/helpers/parseAddrs';
import libmime from 'libmime';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import resize from 'vue-resize-directive';
import MessageControlBar from '@/components/messageControlBar';
import MessagePager from '@/components/messagePager';
import { EventBus } from '@/event-bus';
import AttachmentsViewer from '@/components/attachmentsViewer';
import Modernizr from 'modernizr';

export default {
  name: 'messageView',
  components: { MessageControlBar, iFrame, MessageBody, FontAwesomeIcon, MessagePager, AttachmentsViewer },
  directives: {
    resize
  },
  data: function() {
    return {
      displayParts: [],
      headers: [],
      structure: [],
      attachments: [],
      allowImages: false,
      imagesBlocked: false,
      loading: true,
      rcptsOverflowed: false
    };
  },
  props: {
    folderid: String,
    msgid: String,
    extWindow: Boolean,
    messages: {
      type: Array,
      required: true
    },
    selectedMessageNumber: {
      type: Number,
      required: true
    },
    totalFolderSize: {
      type: Number,
      required: true
    }
  },
  watch: {
    folderid(val) {
      if (val) {
        this.loadMessage();
      }
    },
    msgid() {
      // this.loadMessage();
    },
    message(val) {
      if (val) {
        this.loadMessage();
      }
    }
  },
  created() {
    console.log('message view created', this.folderid, this.msgid);
  },
  mounted() {
    this.loadMessage();
    this.doUpdateControls();
  },
  methods: {
    doResize() {
      this.doUpdateControls();
    },
    doSwipe(evt) {
      if (Modernizr.touch) {
        console.log('swipe', evt);
        if (evt === 'right') {
          this.$emit('page', this.selectedMessageNumber - 1);
        } else if (evt === 'left') {
          this.$emit('page', this.selectedMessageNumber + 1);
        }
      }
    },
    doKeyDown(evt) {
      if (!this.extWindow) {
        if (evt.key === 'ArrowRight') {
          this.$emit('page', this.selectedMessageNumber + 1);
        } else if (evt.key === 'ArrowLeft') {
          this.$emit('page', this.selectedMessageNumber - 1);
        }
      }

      if (evt.key === 'Escape') {
        this.$router.push(`/${this.$route.params.foldertype}/${this.folderid}/` +
          `${this.$route.params.startpos}`);
      } else if ((evt.key === 'Delete') && (this.rights.indexOf('t') !== -1)) {
        this.$emit('deleteMessages', [this.message]);
      }
    },
    onFocusIframe() {
      console.log('focus iframe');
      this.$refs.wrap.focus();
    },
    loadMessage() {
      this.loading = true;
      console.log('loadMessage', this.folderId, this.message);

      this.imagesBlocked = false;
      this.headers = [];

      if (this.folderId && this.message) {
        axios
          .get(`/rest/user/folders/${this.folderId}/${this.message}`)
          .then(d => {
            console.log('got message', d.data);
            this.displayParts = d.data.displayParts;
            this.headers = d.data.headers;
            console.log(this.headers);
            this.structure = d.data.structure;
            this.attachments = d.data.attachments;
            this.allowImages = false;
            this.loading = false;

            let folderId = this.folderId;
            let uid = this.message;
            this.$nextTick(() => {
              this.doUpdateControls();
              if (this.rights.indexOf('s') !== -1) {
                axios
                  .patch(`/rest/user/folders/${folderId}/${uid}`, { read: true })
                  .then(d => {
                    this.$emit('messageUpdated', { folderId, uid, newValues: d.data.msg });
                  });
              }
            });
          })
          .catch(e => {
            console.log(e);
            console.log('Get message failed');
            this.$dialog.alert(this.$t('messageView.loadError', { error: e.message }));
            this.displayParts = [];
            this.headers = [];
            this.structure = [];
            this.$router.push('..');
          })
          .finally(() => {
            console.log('end get message');
          });
      }
    },
    unblockImages(remember) {
      if (this.$store.state.settings.allowwebmailimages) {
        this.allowImages = true;
        if (remember) {
          this.$store.dispatch('addAllowedImageSender', { addr: this.from.addr });
        }
      }
    },
    flagMessage() {
      let folderId = this.folderId;
      let uid = this.message;
      this.$nextTick(() => {
        axios
          .patch(`/rest/user/folders/${folderId}/${uid}`, { flagged: !this.flagged })
          .then(d => {
            this.$emit('messageUpdated', { folderId, uid, newValues: d.data.msg });
          });
      });
    },
    doUpdateControls() {
      const r = this.$refs.recipients;
      this.rcptsOverflowed = r.scrollWidth > r.clientWidth;
    },
    reduceRecipients(rcpts) {
      console.log(rcpts);
      return rcpts.map(r => {
        if (r.nameAuto) {
          return r.addr;
        } else {
          const name = r.name.replace(/([\\"])/g, '\\$1');
          return `"${name}" <${r.addr}>`;
        }
      });
    },
    addPrefix(prefixName, subject) {
      const prefix = this.$t(`messageEditor.${prefixName}`);
      if (subject.indexOf(prefix) === 0) {
        return subject;
      } else if (subject.toUpperCase().indexOf(prefix.toUpperCase()) === 0) {
        return `${prefix} ${subject.substr(prefix.length)}`;
      } else {
        return `${prefix} ${subject}`;
      }
    },
    doMessage(action) {
      const to = this.reduceRecipients(this.recipientsTo);
      const cc = this.reduceRecipients(this.recipientsCc);
      switch (action) {
        case 'reply': {
          let rcpts = [];

          if (this.replyTo.addr) {
            rcpts = [this.replyTo];
          } else {
            rcpts = [this.from];
          }
          console.log('reply1', rcpts);
          EventBus.$emit('compose', {
            rcptsTo: rcpts,
            subject: this.addPrefix('rePrefix', this.subject),
            content: this.$t('messageEditor.reCiteInfo', {
              fromname: this.from.name,
              fromaddr: this.from.addr,
              to: to.join(', '),
              cc: cc.join(', '),
              recipients: [...to, ...cc].join(', '),
              subject: this.subject,
              date: this.dateRaw,
              message: this.$refs.msgbody.getMessageHTML()
            })
          });
          break;
        }
        case 'replyAll': {
          let rcpts = [...this.replyTo, ...[this.from], ...this.recipientsTo, ...this.recipientsCc];
          rcpts = rcpts.filter((r, ind, arr) => arr.findIndex(entry => entry.addr === r.addr) === ind);
          EventBus.$emit('compose', {
            rcptsTo: rcpts,
            subject: this.addPrefix('reAllPrefix', this.subject),
            content: this.$t('messageEditor.reAllCiteInfo', {
              fromname: this.from.name,
              fromaddr: this.from.addr,
              to: to.join(', '),
              cc: cc.join(', '),
              recipients: [...to, ...cc].join(', '),
              subject: this.subject,
              date: this.dateRaw,
              message: this.$refs.msgbody.getMessageHTML()
            })
          });
          break;
        }
        case 'replyList': {
          if (this.canReplyList) {
            const rcpts = [{ name: '', addr: this.listPostAddress }];
            EventBus.$emit('compose', {
              rcptsTo: rcpts,
              subject: this.addPrefix('reListPrefix', this.subject),
              content: this.$t('messageEditor.reListCiteInfo', {
                fromname: this.from.name,
                fromaddr: this.from.addr,
                to: to.join(', '),
                cc: cc.join(', '),
                recipients: [...to, ...cc].join(', '),
                subject: this.subject,
                date: this.dateRaw,
                message: this.$refs.msgbody.getMessageHTML()
              })
            });
          } else {
            this.doMessage('reply');
          }
          break;
        }
        case 'forward': {
          let attachments = this.attachments
            .map((a, ind) => {
              let att = Object.assign({}, a);
              if ((att.attachment) && (att.name === '')) {
                att.name = 'Attachment';
              }
              att.index = ind;
              att.url = '/rest/user/folders/' + this.folderId + '/' + this.message + '/attachment/' + att.id;
              return att;
            })
            .filter(s => s.attachment);
          // console.log('a2', attachments);

          EventBus.$emit('compose', {
            rcptsTo: [],
            subject: this.addPrefix('fwPrefix', this.subject),
            content: this.$t('messageEditor.fwCiteInfo', {
              fromname: this.from.name,
              fromaddr: this.from.addr,
              to: to.join(', '),
              cc: cc.join(', '),
              recipients: [...to, ...cc].join(', '),
              subject: this.subject,
              date: this.dateRaw,
              message: this.$refs.msgbody.getMessageHTML()
            }),
            attachments
          });
        }
          break;
      }
    },
    doMenu(menu) {
      console.log('messageView menu', menu);
      if (this.hasOwnProperty(menu)) {
        this[menu]();
      } else {
        console.log('propagate menu', menu);
        this.$emit('menu', menu);
      }
    },
    addManualRule() {
      let subj = this.subject;
      let subjMatch = 'is';
      const m = /^(?:Re: *)?(\[.*\])/.exec(subj);
      if (m) {
        subj = m[1];
        subjMatch = 'contains';
      }
      this.$store.commit('setNewRule', {
        name: `Filter: ${subj}`,
        all: true,
        conditions: [
          { field: 'subject', match: subjMatch, data: subj },
          { field: 'from', match: 'is', data: this.from.addr }
        ],
        actions: []
      });
      const r = { name: 'manualRuleEditor', params: this.$route.params };
      r.params.ruleid = '-1';
      this.$router.push(r);
    }
  },
  computed: {
    spamdata() {
      return this.headerMap['x-vpop3-spam'];
    },
    subject() {
      return libmime.decodeWords(this.headerMap['subject']);
    },
    replyTo() {
      return parseAddrs(this.headerMap['reply-to']);
    },
    from() {
      const fm = parseAddrs(this.headerMap['from']);
      if (fm.length > 0) {
        return fm[0];
      } else {
        return { name: '', addr: '' };
      }
    },
    fromAddr() {
      const fm = this.from;
      if (fm.name === fm.addr) {
        return '';
      } else {
        return `<${fm.addr}>`;
      }
    },
    fromName() {
      const fm = this.from;
      if (fm.name === '') {
        if (fm.addr === '') {
          return this.$t('messageView.fromUnknown');
        } else {
          return fm.addr;
        }
      } else {
        return fm.name;
      }
    },
    recipientsTo() {
      return parseAddrs(this.headerMap['to']);
    },
    recipientsCc() {
      return parseAddrs(this.headerMap['cc']);
    },
    dateRaw() {
      if (!this.headerMap['date']) {
        return '';
      }
      return DateTime.fromRFC2822(this.headerMap['date']);
    },
    date() {
      if (!this.headerMap['date']) {
        return '';
      }
      return DateTime.fromRFC2822(this.headerMap['date']).toLocaleString(DateTime.DATETIME_MED);
    },
    headerMap() {
      return this.headers.reduce((map, hdr) => {
        map[hdr[0].toLowerCase()] = hdr[1];
        return map;
      }, {});
    },
    allowSenderImages() {
      if (!this.$store.state.settings.allowwebmailimages) {
        return false;
      }
      if (this.$store.state.settings.alwaysshowimages) {
        return true;
      }
      return this.$store.getters.areImagesAllowed(this.from.addr);
    },
    message() {
      return parseInt(this.msgid, 10);
    },
    folderId() {
      return parseInt(this.folderid, 10);
    },
    flagged() {
      const msg = this.messages.find(m => m.uid === this.message);
      if (msg) {
        return msg.flagged;
      } else {
        return false;
      }
    },
    rights() {
      const f = this.$store.getters.getFolderById(this.folderId);
      if (f) {
        return f.rights;
      } else {
        return 'lr';
      }
    },
    listPostAddress() {
      const listPost = this.headerMap['list-post'];
      console.log('reply List', listPost);
      if (listPost) {
        const m = /^<mailto:(\S+@[a-z0-9.-]+)>$/i.exec(listPost);
        if (m) {
          return m[1];
        }
      }
      return null;
    },
    canReplyList() {
      return !!this.listPostAddress;
    },
    title() {
      return this.$t('messageView.htmlTitle', { user: this.$store.state.username,
        folder: this.$store.getters.getFolderById(this.folderId).name,
        subject: this.subject,
        fromName: this.fromName,
        fromAddr: this.fromAddr
      });
    }
  }
};
</script>

<style>

</style>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .messageviewwrap {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: grid;
        grid-template-columns: 1fr auto;
        grid-template-rows: 50px minmax(0, 1fr);
        grid-template-areas: "controls pager" "messages messages";
    }
    .controls {
        grid-area: controls;
    }
    .pager {
        grid-area: pager;
    }
    .messagecontentwrap {
        grid-area: messages;
        animation-duration: 0.2s;
        height: calc(100vh - 90px);
        overflow-y: scroll;
        overflow-x: auto;
        position: relative;

        .messageloading {
            position: absolute;
            z-index: 1000;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: $gray-100;
            div {
                display: inline-block;
                margin: auto;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }

        &.loading {
            overflow-y: hidden;
        }

        header {
            padding: 0 10px 0 10px;
            background-color: $msgheader-background;
            display: grid;
            width: 100%;
            grid-template-columns: 1fr 9em 20px;
            grid-template-rows: 2.5em 1.5em 1.5em auto;
            grid-template-areas: "subject subject subject" "from date flag" "recipients recipientsoverflow flag"
            "spamdata spamdata spamdata";
            border-bottom: 1px solid $gray-400;

            .subject {
                grid-area: subject;
                font-size: 150%;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .from {
                grid-area: from;
                font-weight: bold;
                .fromextra {
                    font-size: 70%;
                    font-weight: normal;
                    color: $gray-800;
                }
            }
            .date {
                grid-area: date;
                color: $gray-800;
                font-size: 70%;
            }
            .recipients {
                grid-area: recipients;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                .rcptWrap {
                    margin-right: 0.3em;
                }
                .rcptLabel {
                    font-size: 0.7em;
                    font-style: italic;
                }
            }
            .recipientsoverflow {
                grid-area: recipientsoverflow;
                background-color: red;
            }
            .spamdata {
                grid-area: spamdata;
            }
            .flag {
                grid-area: flag;
                .flagged {
                    color: $flaggedstar;
                }
            }
        }
        .imagesBlocked {
            background-color: $danger;
            color: $light;
            padding: 3px 10px;
            font-size: 70% !important;
            a {
                color: $warning;
                font-weight: bold;
                &:hover {
                    text-decoration: underline;
                }
            }
        }
        #msgiframe {
            border: none;
            width: 100%;
            height: 100%;
        }
    }

</style>
